export const invStratMixin = {
  computed: {
    isInvStratMembersInfoSubmitted() {
      const invStrat = this.$store.getters['toolkit/getItemData'];
      if (invStrat.memberInfo === true
        && invStrat.members !== undefined
        && invStrat.members.length > 0
      ) {
        return invStrat.members[0].additionalInfo !== undefined
          && invStrat.members[0].additionalInfo.length !== 0
          && invStrat.members[0].additionalInfo.currentWorkStatus.value !== '';
      }
      return false;
    },
  },
};

export default invStratMixin;
